import { getOS, iphoneXCheck } from './os.js'
import { getBrowser, getBrowserVersion } from './browser.js'
import { MP_TYPES, getMiniprogramType } from './miniProgram.js'
import { extractFromQuery } from './query.js'

export const DEFAULT_RESULT = {
  isXHS: false,
  isIOS: false,
  isAndroid: false,
  isWeixin: false,
  isAlipay: false,
  isWeibo: false,
  isQQ: false,
  isMiniprogram: false,
  isBaiduMiniprogram: false,
  isQQMiniprogram: false,
  isAlipayMiniprogram: false,
  isToutiaoMiniprogram: false,
  isIphoneX: false,
  isFullscreen: false,
  isTop: false,
  isUniik: false,
}

export function commonChecks(win) {
  const { navigator, location } = win
  const { userAgent } = navigator

  const os = getOS(userAgent)
  const browser = getBrowser(userAgent)
  const miniProgramType = getMiniprogramType(userAgent, win)
  const checkIPhoneX = iphoneXCheck(os)

  const envFromQuery = extractFromQuery(location.search)

  const isIOS = os === 'iOS'

  const hasXhsBridgeForAndroid = !!window.xhsbridge
  const hasXhsBridgeForIOS = !!window.webkit?.messageHandlers?.getDeviceInfo
  const isXHS = hasXhsBridgeForAndroid || hasXhsBridgeForIOS || browser === 'discover' || envFromQuery.isXHS
  const isTop = browser === 'redtop'

  let isFullscreen = false

  if (isXHS || isTop) {
    const appVersion = getBrowserVersion(userAgent)
    const isSupportVersion = appVersion.major > 6
      || (appVersion.major === 6 && appVersion.minor >= 7)

    isFullscreen = (isSupportVersion && envFromQuery.isFullscreen)
      || (isIOS && envFromQuery.isNaviHidden)
      || (isTop && envFromQuery.isFullscreen) // 友友视频有 fullscreen 参数即可
  }

  return {
    ...DEFAULT_RESULT,
    isIOS,
    isAndroid: os === 'Android',
    isXHS,
    isFullscreen,
    isWeixin: browser === 'micromessenger',
    isAlipay: browser === 'alipay',
    isWeibo: browser === 'weibo',
    isQQ: browser === 'qq',
    isMiniprogram: miniProgramType === MP_TYPES.weixin || envFromQuery.isMiniprogram,
    isBaiduMiniprogram: miniProgramType === MP_TYPES.baidu,
    isQQMiniprogram: miniProgramType === MP_TYPES.qq,
    isAlipayMiniprogram: miniProgramType === MP_TYPES.alipay,
    isToutiaoMiniprogram: miniProgramType === MP_TYPES.toutiao,
    isIphoneX: checkIPhoneX.isIphoneX,
    iphoneXType: checkIPhoneX.iphoneXType,
    isTop,
    isUniik: browser === 'uniik',
  }
}
